import {type IAsset} from '@netx/core-asset-next/schema';
import {assetIsPresent} from '@netx/core-asset-next/enablers/assetIsPresent';
import {
	assetPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';
import {
	REPURPOSE_SUPPORTED_FILE_FORMAT_FAMILIES,
	REPURPOSE_SUPPORTED_VIEW_NAMES,
} from '../constants';
import {userCanRepurpose} from './userCanRepurpose';

export const canRepurposeAsset = (asset?: IAsset): boolean => {
	if (asset == null || !asset.repurposeAvailability) return false;
	// DAM-13617
	if (!userCanRepurpose()) return false;
	if (!assetIsPresent(asset)) return false;

	const {viewNames, fileFormatFamily} = asset;

	// Once the property repurposeAvailability is considering
	// the availability of the engines required to repurpose
	// an asset ( https://jira.netx.net/browse/DAM-4564 ) we
	// can rely more heavily on `repurposeAvailability` until
	// that time... ~SAK
	const hasRepuposableFileType =
		REPURPOSE_SUPPORTED_FILE_FORMAT_FAMILIES.some((supportedFileFormatFamily) =>
			fileFormatFamily.includes(supportedFileFormatFamily),
		) ||
		REPURPOSE_SUPPORTED_VIEW_NAMES.some((supportedViewName) =>
			viewNames.includes(supportedViewName),
		);

	if (!hasRepuposableFileType) return false;

	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.DOWNLOAD,
		permissionName: PermissionName.DOWNLOAD,
	});
};
